import { Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { NavController, NavParams, ViewController } from "ionic-angular";
import { AuthService } from "../../../app/auth/auth.service";
import { commonVar } from "../../../providers/common-var/common";
import { eFaxAssessment } from "./efax-assessment";

/**
 * Generated class for the EFaxAssessmentPopupPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: "efax-assessment-popup",
  templateUrl: "efax-assessment-popup.html",
})
export class EFaxAssessmentPopupPage {
  modalData: any = {};
  validForm: boolean = false;
  efaxForm: FormGroup;
  phoneMask = commonVar.PHONE_US_MASK;
  phoneUsPlaceHolder = commonVar.PHONE_US_PLACEHOLDER;
  assessmentId: any;
  patientChartId: any;
  efaxAssessment: eFaxAssessment;

  constructor(
    public viewCtrl: ViewController,
    public navCtrl: NavController,
    public navParams: NavParams,
    private authService: AuthService,
    private authSvc: AuthService
  ) {
    this.modalData = this.navParams.data;
    this.assessmentId = this.modalData.assessmentId;
    this.patientChartId = this.modalData.patientChartId;
  }

  ngOnInit() {
    this.efaxForm = new FormGroup({
      name: new FormControl("", Validators.maxLength(150)),
      fax: new FormControl(
        "",
        Validators.compose([Validators.pattern(commonVar.PHONE_REGEX)])
      ),
    });
  }

  onSubmit(event: any) {
    let data = {
      name: this.efaxForm.controls["name"].value,
      fax: this.efaxForm.controls["fax"].value,
      patientChartId: this.patientChartId,
      //  orgId: this.authSvc.getUserOrganization()
      orgId: this.authSvc.getUser().tenantId,
    };
    this.viewCtrl.dismiss(data);
  }

  onDismiss() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/assessment/efax-assessment-popup/efax-assessment-popup.ts